module.exports = __webpack_public_path__ + "static/media/attendence.73128849.png";